var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"d-flex flex-column justify-center align-center mt-12",attrs:{"height":"50vh"}},[_c('h1',{staticClass:"text-center"},[_vm._v("404")]),_c('h2',{staticClass:"text-center"},[_vm._v("Page introuvable")]),_c('h3',{staticClass:"text-center"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Retourner a l'acceuil")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }